export function initExpandContent(): void {
	const buttons = document.querySelectorAll<HTMLElement>('.js-expand-btn');

	buttons.forEach((btn) => {
		const controls = btn.getAttribute('aria-controls');

		if (!controls) return;

		const target = document.getElementById(controls);

		if (!target) return;

		btn.addEventListener('click', () => {
			btn.setAttribute('aria-expanded', 'true');
			target.classList.add('is-expanded');
		});
	});
}
